import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export function ColumnPanel(props) {
    const {
        headline,
        subheadline,
        columns,
        variant,
        id
    } = props;

    const columnCount = columns.length;

    const classesSet = {
        V1: {
            section: `ulx__aem-column-panel ulx__aem-section ulx__aem-column-panel__${columnCount}-column`,
            header: 'ulx__aem-column-panel__subhead',
            content: 'ulx__aem-column-panel__column-container',
            column: 'ulx__aem-column-panel__column',
            c_copy: 'ulx__aem-column-panel__column-copy'
        },
        V2: {
            section: cn('column-panel-section', 'ulx__aem-section'),
            header: cn('section-header'),
            content: cn('section-content'),
            column: cn('column'),
            c_copy: cn('column-copy')
        }
    };
    const classesToUse = classesSet[variant];
    // eslint-disable-next-line arrow-body-style
    const renderColumn = (column) => {
        return (
            <div key={column.key} className={classesToUse.column}>
                {column.image && (<img src={column.image.url} loading="lazy" alt={column.image.alt} width="90" height="90" />)}
                <h3>{column.head}</h3>
                <p className={classesToUse.c_copy}>{column.body}</p>
                {(column.link && column.link.url && column.link.text) && (
                    <a href={column.link.url}>{column.link.text}</a>
                )}
            </div>
        );
    };

    const renderColumns = (columnData) => columnData.map((column) => renderColumn(column));

    return (
        <section className={classesToUse.section} id={id}>
            <div className={classesToUse.header}>
                <h2>{headline}</h2>
                <p>{subheadline}</p>
            </div>
            <div className={classesToUse.content}>{renderColumns(columns)}</div>
        </section>
    );
}

ColumnPanel.propTypes = {
    id: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    subheadline: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape(
        {
            index: PropTypes.number.isRequired,
            head: PropTypes.string.isRequired,
            body: PropTypes.string.isRequired,
            image: PropTypes.shape({
                url: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired
            }),
            link: PropTypes.shape({
                url: PropTypes.string.isRequired,
                text: PropTypes.string.isRequired
            })
        }
    )).isRequired,
    variant: PropTypes.string
};

ColumnPanel.defaultProps = {
    variant: 'V1'
};

export default ColumnPanel;
